"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var utils_1 = require("../../utils");
var themes_1 = require("../../themes");
var getContainedButtonStyle = function (theme, _a) {
    var color = _a.color;
    switch (color) {
        case 'error':
            return {
                backgroundColor: theme.palette.error.main,
                color: theme.palette.error.contrastText,
                '&:hover': {
                    backgroundColor: theme.palette.error.dark,
                },
            };
        case 'primary':
        default:
            return {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                '&:hover': {
                    backgroundColor: theme.palette.primary.dark,
                },
            };
    }
};
var getOutlinedButtonStyle = function (theme, _a) {
    var color = _a.color;
    switch (color) {
        case 'error':
            return {
                color: theme.palette.error.main,
                borderColor: theme.palette.error.main,
                '&:hover': {
                    backgroundColor: themes_1.materialColors.red[100],
                },
            };
        case 'primary':
        default:
            return {
                color: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
                '&:hover': {
                    backgroundColor: themes_1.materialColors.blue[100],
                },
            };
    }
};
var getTextButtonStyle = function (theme, _a) {
    var color = _a.color;
    switch (color) {
        case 'error':
            return {
                color: theme.palette.error.main,
            };
        case 'secondary':
            return {
                color: themes_1.materialColors.grey[500],
            };
        case 'dark':
            return {
                color: themes_1.materialColors.grey[600],
            };
        case 'primary':
        default:
            return {
                color: theme.palette.primary.main,
            };
    }
};
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var size = _a.size, color = _a.color, asLink = _a.asLink;
            return ({
                height: size === 'large' ? 56 : 'unset',
                padding: !asLink ? '8px 16px' : '0',
                textDecoration: asLink ? 'underline' : undefined,
                fontSize: size === 'large' ? utils_1.textSizeMap.text.large : utils_1.textSizeMap.text.small,
                fontWeight: utils_1.textWeightMap['semi-bold'],
                '&:not(.MuiButton-text)': {
                    borderRadius: size === 'large' ? 20 : 16,
                },
                '&.MuiButton-contained': {
                    borderRadius: '1000px',
                    '&:not(.Mui-disabled)': __assign({}, getContainedButtonStyle(theme, { color: color })),
                    '&.Mui-disabled': {
                        backgroundColor: "".concat(themes_1.materialColors.grey[100]),
                        color: themes_1.materialColors.grey[200],
                    },
                },
                '&.MuiButton-outlined': {
                    borderRadius: '1000px',
                    '&:not(.Mui-disabled)': __assign({}, getOutlinedButtonStyle(theme, { color: color })),
                    '&.Mui-disabled': {
                        borderColor: "".concat(themes_1.materialColors.grey[100]),
                        color: themes_1.materialColors.grey[200],
                    },
                },
                '&.MuiButton-text': {
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    '&:not(.Mui-disabled)': __assign(__assign({}, getTextButtonStyle(theme, { color: color })), { '&:hover': {
                            textDecoration: 'underline',
                        } }),
                    '&.Mui-disabled': {
                        color: themes_1.materialColors.grey[200],
                    },
                },
            });
        },
        contained: {
            boxShadow: '-2px 2px 4px 0 rgba(0, 0, 0, 0.3)',
        },
        disableElevation: {
            boxShadow: 'none',
        },
    });
});
